export const LOADING_STATE = {
  RETRYING: 'RETRYING',
  LOADING: 'LOADING',
  ERROR: 'ERROR',
  SENT: 'SENT',
};
